import styled from "styled-components"
import BackButton from "../Images/BackButton"

export const head = {
    // width : '600px',
    height : '120px',
    bg : '#e0e2eb'
}

export const innerContent = {
  width: ['auto','calc(100% - 48px)'],
  m: 'auto',
  pt: '32px'
}

export const title = {
  mb: '24px',
  px: '8px',
  fontSize: '24px',
  fontWeight: '600',
  lineHeight: '1.33',
  color: 'text.text700'
}

export const bottomBGSection = {
  bg: '#f6f7f9',
}

export const BackBtn = styled(BackButton)`
    margin: 4px;
`
export const emptyState = {
  py: '56px',
  px : '24px',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backfaceVisibility: 'hidden',
  mb: '32px',
  backgroundColor: 'surface.foreground'
}

export const noResultsText = {
  fontSize: '24px',
  fontWeight: '600',
  lineHeight:'1.33',
  color: 'text.text500',
  mt: '32px',
  mb: '8px',
  textAlign: 'center'
}
export const noResultsSubtext = {
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '1.5',
  color: 'rgba(13, 21, 54, 0.65)',
  textAlign: 'center'
}